import { Cliente, ProcessoInfo, ChecklistItem } from '../types';
import { DocumentFormatter } from './documentFormatter';
import { logger } from './logger';

export class WordExporter {
  private static async converterImagemParaBase64(): Promise<string> {
    try {
      // Tenta carregar a imagem do diretório público
      const response = await fetch('/assets/cidadania4u-logohorizontal-original.png');
      if (!response.ok) {
        throw new Error('Imagem não encontrada');
      }
      const blob = await response.blob();
      
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      logger.error('Erro ao carregar logo:', error);
      // Retorna uma imagem placeholder em base64 se não conseguir carregar
      return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgMjAwIDYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjNzQwNTI5Ii8+Cjx0ZXh0IHg9IjEwMCIgeT0iMzUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0id2hpdGUiIHRleHQtYW5jaG9yPSJtaWRkbGUiPkNpZGFkYW5pYSA0VTwvdGV4dD4KPC9zdmc+';
    }
  }

  static async exportarChecklist(
    cliente: Cliente,
    processoInfo: ProcessoInfo,
    itens: ChecklistItem[]
  ): Promise<void> {
    const checklistFormatado = DocumentFormatter.gerarChecklist(itens);
    const logoBase64 = await this.converterImagemParaBase64();
    
    const conteudo = this.gerarConteudoHTML(cliente, processoInfo, checklistFormatado, logoBase64);
    const blob = new Blob(['\ufeff', conteudo], { type: "application/msword" });
    
    const nomeCliente = cliente['name_cliente'] || 'Cliente';
    this.downloadFile(blob, `Checklist_${nomeCliente}.doc`);
  }

  private static gerarConteudoHTML(
    cliente: Cliente,
    processoInfo: ProcessoInfo,
    checklist: string[],
    logoBase64: string
  ): string {
    return `<html xmlns:o='urn:schemas-microsoft-com:office:office' 
                xmlns:w='urn:schemas-microsoft-com:office:word' 
                xmlns='http://www.w3.org/TR/REC-html40'>
        <head>
          <meta charset='utf-8'>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              font-size: 12pt;
              margin: 20px;
            }
            ul, li { 
              list-style-type: none; 
              margin: 0; 
              padding: 0; 
            }   
            h3 { 
              border: 1px solid black; 
              padding: 5px; 
              background-color: #f5f5f5;
            }
            #header { 
              color: #740529; 
              margin: 10px 0; 
              line-height: 1.4;
            }
            #header p { 
              font-size: 1.1em; 
              margin: 5px 0;
            }
            .checklist-item {
              margin: 8px 0;
              font-size: 11pt;
            }
            #document-header {
              text-align: center;
              margin-bottom: 20px;
              padding-bottom: 15px;
              border-bottom: 2px solid #740529;
            }
            .company-logo {
              height: 60px;
              width: auto;
              margin-bottom: 10px;
            }
            #document-header h2 {
              margin: 0;
              color: #740529;
              font-size: 1.8em;
            }
          </style>
        </head>
        <body>
          <div id="document-header">
            ${logoBase64 ? `<img src="${logoBase64}" alt="Cidadania4u" class="company-logo" />` : ''}
            <h2><b>Checklist Espanha</b></h2>
          </div>
          <div id="header">
            <p><strong>Tipo do Processo:</strong> ${processoInfo.tipoProcesso}</p>
            <p><strong>Cliente:</strong> ${processoInfo.nomeClienteApp}</p>
            <p><strong>Requerente:</strong> ${cliente['name_cliente'] || 'Nome não informado'}</p>
            <p><strong>Endereço:</strong> ${cliente['end_ciente'] || 'Endereço não informado'}, ${cliente['cidade'] || 'Cidade não informada'}, ${cliente['estado'] || 'Estado não informado'}, CEP: ${cliente['cep'] || 'CEP não informado'}</p>
            <p><strong>Atividade de envio:</strong> ${processoInfo.atividadeEnvio}</p>
          </div>
          <h3>Documentos Necessários:</h3>
          <div>
            ${checklist.map(item => `<p class="checklist-item">✅ ${item}</p>`).join('')}
          </div>
        </body>
      </html>`;
  }

  private static downloadFile(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}
